<template>
  <div>
    <q-form ref="editForm">
      <c-card :noHeader="true" class="cardClassDetailForm" topClass="topcolor-blue">
        <template slot="card-detail">
          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
            <c-textarea
              :editable="param.editable"
              label="내용물"
              name="inMaterials"
              :rows="5"
              v-model="item.inMaterials">
            </c-textarea>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
            <c-textarea
              :editable="param.editable"
              label="용량"
              name="volume"
              :rows="5"
              v-model="item.volume">
            </c-textarea>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
            <c-text
              suffix="MPa"
              :editable="param.editable"
              label="압력(MPa)-운전"
              name="pressOperation"
              v-model="item.pressOperation">
            </c-text>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
            <c-text
              suffix="MPa"
              :editable="param.editable"
              label="압력(MPa)-설계"
              name="pressDesign"
              v-model="item.pressDesign">
            </c-text>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
            <c-text
              suffix="℃"
              :editable="param.editable"
              label="온도(℃)-운전"
              name="tempOperation"
              v-model="item.tempOperation">
            </c-text>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
            <c-text
              suffix="℃"
              :editable="param.editable"
              label="온도(℃)-설계"
              name="tempDesign"
              v-model="item.tempDesign">
            </c-text>
          </div>
        </template>
      </c-card>
      <c-card :noHeader="true" class="cardClassDetailForm" topClass="topcolor-blue">
        <template slot="card-detail">
          <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
            <c-textarea
              :editable="param.editable"
              label="사용재질-본체"
              name="materialMain"
              :rows="1"
              v-model="item.materialMain">
            </c-textarea>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
            <c-textarea
              :editable="param.editable"
              label="사용재질-부속품"
              name="materialSubPart"
              :rows="1"
              v-model="item.materialSubPart">
            </c-textarea>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
            <c-textarea
              :editable="param.editable"
              label="사용재질-개스킷"
              name="materialGasket"
              :rows="1"
              v-model="item.materialGasket">
            </c-textarea>
          </div>
        </template>
      </c-card>
      <c-card :noHeader="true" class="cardClassDetailForm" topClass="topcolor-blue">
        <template slot="card-detail">
          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
            <c-text
              :editable="param.editable"
              label="용법효율"
              name="weldingEfficiency"
              v-model="item.weldingEfficiency">
            </c-text>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
            <c-text
              suffix="mm"
              :editable="param.editable"
              label="계산두께(mm)"
              name="calculateThick"
              v-model="item.calculateThick">
            </c-text>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
            <c-text
              suffix="mm"
              :editable="param.editable"
              label="부식여유(mm)"
              name="corrosionAllowance"
              v-model="item.corrosionAllowance">
            </c-text>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
            <c-text
              suffix="mm"
              :editable="param.editable"
              label="사용두께(mm)"
              name="useThick"
              v-model="item.useThick">
            </c-text>
          </div>
        </template>
      </c-card>
      <c-card :noHeader="true" class="cardClassDetailForm" topClass="topcolor-blue">
        <template slot="card-detail">
          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
            <c-select
              :editable="param.editable"
              :comboItems="afterHeatTreatYnItems"
              type="edit"
              itemText="codeName"
              itemValue="code"
              name="afterHeatTreatYn"
              label="후열처리 여부"
              v-model="item.afterHeatTreatYn"
            ></c-select>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
            <c-text
              suffix="%"
              :editable="param.editable"
              label="비파괴검사율(%)"
              name="nondestructPercent"
              v-model="item.nondestructPercent">
            </c-text>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
            <c-text
              :editable="param.editable"
              label="적용법령"
              name="applicableLaws"
              v-model="item.applicableLaws">
            </c-text>
          </div>
        </template>
      </c-card>
    </q-form>
  </div>
</template>

<script>
export default {
  name: 'device-machine-detail',
  props: {
    param: {
      type: Object,
      default: () => ({
        psiDeviceEquipmentId: '',
        devicePartCd: '',
        devicePartName: '',
        editable: false,
      }),
    },
    item: {
      type: Object,
      default: () => ({
        psiDeviceEquipmentId: '',  // 장치일련번호
        devicePartCd: '',  // 장치구분
        inMaterials: '',  // 내용물
        volume: '',  // 용량
        pressOperation: '',  // 압력(Mpa)-운전
        pressDesign: '',  // 압력(Mpa)-설계
        tempOperation: '',  // 온도(℃)-운전
        tempDesign: '',  // 온도(℃)-설계
        materialMain: '',  // 사용재질-본체
        materialSubPart: '',  // 사용재질-부속품
        materialGasket: '',  // 사용재질-개스킷
        weldingEfficiency: '',  // 용접효율
        calculateThick: '',  // 계산두께(mm)
        corrosionAllowance: '',  // 부식여유(mm)
        useThick: '',  // 사용두께(mm)
        afterHeatTreatYn: 'N',  // 후열처리여부
        nondestructMethod: '',  // 비파괴검사방법
        nondestructPercent: '',  // 비파괴검사율(%)
        applicableLaws: '',  // 적용법령
        regUserId: this.$store.getters.user.userId,
        chgUserId: this.$store.getters.user.userId,
      }),
    },
  },
  data() {
    return {
      afterHeatTreatYnItems: [
        { code: 'Y', codeName: 'Y' },
        { code: 'N', codeName: 'N' },
      ],
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  watch: {
    param() {
    }
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.item.psiDeviceEquipmentId = this.param.psiDeviceEquipmentId;
      this.item.devicePartCd = this.param.devicePartCd;
      this.item.regUserId = this.$store.getters.user.userId;
      this.item.chgUserId = this.$store.getters.user.userId;
    },
  }
};
</script>
